<div class="content-block">
  <div class="content-header">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">
          <h2>Gestione <b> Utenti </b></h2>
        </div>
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a href="/home">Dashboard</a></li>
            <li class="breadcrumb-item">Tabelle</li>
            <li class="breadcrumb-item active">Utenti</li>
          </ol>
        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-header primary">
      <span class="float-start">
        <dx-button stylingMode="contained" icon="plus" type="success" text="Nuovo utente" [visible]="true"
          (onClick)="nuovoUtente()">
        </dx-button>
      </span>
    </div>

    <div class="card-body">
      <dx-data-grid #grid [dataSource]="gestioneUtentiSource" [showBorders]="true" [focusedRowEnabled]="true"
        [focusedRowIndex]="0" [columnAutoWidth]="true" [showColumnLines]="true" [showRowLines]="true"
        [rowAlternationEnabled]="true" (onRowUpdating)="onUpdating($event)" (onExporting)="onExporting($event)">

        <dxo-export [enabled]="true"></dxo-export>

        <dxo-paging [pageSize]="20"> </dxo-paging>
        <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[10, 20, 50]">
        </dxo-pager>

        <dxo-editing mode="batch" [allowUpdating]="true" [allowDeleting]="true" [useIcons]="true">
          <dxo-texts confirmDeleteMessage="Confermare la cancellazione?"></dxo-texts>
        </dxo-editing>

        <dxo-filter-row [visible]="false"></dxo-filter-row>

        <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>

        <dxi-column type="buttons" [width]="40">
          <dxi-button name="delete"></dxi-button>
        </dxi-column>

        <dxi-column dataField="id" caption="IdUtente" width="120" [visible]="false">
        </dxi-column>

        <dxi-column dataField="username" caption="Username" width="120" [allowEditing]="true">
        </dxi-column>


        <dxi-column dataField="livello" caption="Ruolo" [allowEditing]="true">
          <dxo-lookup [dataSource]="listRuoli" valueExpr="idRuolo" displayExpr="decodifica">
          </dxo-lookup>
        </dxi-column>

        @if(authBase){
        <dxi-column dataField="escludiPolicyPassword" caption="Disabilita Policy Password" alignment="center"
          dataType="boolean" [allowEditing]="true">
        </dxi-column>

        <dxi-column dataField="utenteBloccato" caption="Bloccato" alignment="center" cellTemplate="bloccatoTemplate"
          [allowEditing]="false">
        </dxi-column>
        <div *dxTemplate="let d of 'bloccatoTemplate'">
          @if (d.data.utenteBloccato) {
          <i class="dx-icon-warning" title="Utente bloccato"></i>
          }
        </div>
        }
        @if(authAvanzato){
        <dxi-column dataField="nomeEntraId" caption="Nome EntraId" [allowEditing]="true"></dxi-column>
        <dxi-column dataField="objectId" caption="Object EntraId" [allowEditing]="true"></dxi-column>
        }
        @if(authBase){
        <dxi-column fixedPosition="left" visibleIndex="1" name="detail§ModificaPassword" [allowFiltering]="false"
          [allowSorting]="false" cellTemplate="modificaPassword" width="30" caption="" [visible]="true"
          [allowEditing]="false">
        </dxi-column>

        <div *dxTemplate="let d of 'modificaPassword'">
          <i class="dx-icon-key" (click)="onModificaPasswordClick(d)" style="cursor: pointer" data-toggle="tooltip"
            data-placement="top" title="modifica password"></i>
        </div>
        }

        <dxi-column dataField="idsReparti" cellTemplate="viewCodici" editCellTemplate="editCodici"></dxi-column>

        <div *dxTemplate="let d of 'viewCodici'">
          @if (!d.value) {
          Tutti i reparti visibili
          } @else {
          {{ viewReparti(d.data) }}
          }
        </div>

        <div *dxTemplate="let d of 'editCodici'">
          <dx-tag-box [dataSource]="listReparti" valueExpr="id" [displayExpr]="displayExprReparto"
            [searchEnabled]="true" [value]="getRepartiValue(d.value)" (onValueChanged)="onRepartiChanged($event, d)"
            stylingMode="outlined">
          </dx-tag-box>
        </div>

      </dx-data-grid>
    </div>
  </div>
</div>

<!--INSERIMENTO NUOVO UTENTE-->
@if (popupVisible) {
<div>
  <dx-popup [showTitle]="true" title="Nuovo utente" cssClass="popup-nuovo-utente" [minHeight]="'40vh'" [height]="'auto'"
    [maxHeight]="'90vh'" [width]="'65vw'" [(visible)]="popupVisible">
    <div>
      <form>
        <dx-validation-group #targetGroup>
          <div class="row">
            <div class="col-xs-12 col-lg-12">
              <div class="dx-field">
                <div class="dx-field-label">Username:</div>
                <div class="dx-field-value">
                  <dx-text-box [(value)]="newUtente.username">
                    <dx-validator>
                      <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                  </dx-text-box>
                </div>
              </div>
              <div class="dx-field">
                <div class="dx-field-label">Ruolo:</div>
                <div class="dx-field-value">
                  <dx-lookup id="listRuoli" [dataSource]="listRuoli" valueExpr="idRuolo" displayExpr="decodifica"
                    [searchEnabled]="false" [showClearButton]="false" [(value)]="idRuolo">
                    <dx-validator>
                      <dxi-validation-rule type="required" message="Richiesto"></dxi-validation-rule>
                    </dx-validator>
                  </dx-lookup>
                </div>
              </div>

              <div class="dx-field">
                <div class="dx-field-label label-multiline">Reparti visibili <br>
                  <b>(Non selezionare nulla per vederli tutti)</b>
                </div>
                <div class="dx-field-value" style="display: flex; flex-direction: column;">
                  <dx-tag-box [dataSource]="listReparti" valueExpr="codice" [displayExpr]="displayExprReparto"
                    [searchEnabled]="true" (onValueChanged)="onRepartiNewUtente($event)" [showSelectionControls]="true"
                    applyValueMode="useButtons" placeholder="Seleziona i reparti..." [showClearButton]="true"
                    [maxDisplayedTags]="3" stylingMode="outlined">
                  </dx-tag-box>
                </div>
              </div>
              @if(authAvanzato){
              <div class="dx-field">
                <div class="dx-field-label">Nome EntraId:</div>
                <div class="dx-field-value">
                  <dx-text-box [(value)]="newUtente.nomeEntraId"  (onValueChanged)="isPasswordObbligatoria()">
                   <!-- <dx-validator>
                      <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                  -->
                  </dx-text-box>
                </div>
              </div>
              <div class="dx-field">
                <div class="dx-field-label">Object EntraID:</div>
                <div class="dx-field-value">
                  <dx-text-box [(value)]="newUtente.objectId" (onValueChanged)="isPasswordObbligatoria()">
                    <!--<dx-validator>
                      <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                  -->
                  </dx-text-box>
                </div>
              </div>
              }
              @if(authBase){
              <div class="dx-field">
                <div class="dx-field-label">Escludi Policy Password: </div>
                <div class="dx-field-value">
                  <dx-check-box [(value)]="newUtente.escludiPolicyPassword">
                  </dx-check-box>
                </div>
              </div>
              }
              @if(authBase){
              <app-ildato-new-password [parametriPasswords]="parametriPasswords" [passwordObbligatoria]="passwordObbligatoria" (ilDatoNewPasswordEventEmitter)="
                    onIlDatoNewPasswordEvent($event)"></app-ildato-new-password>
              }
               @if (messaggioErrore) {
                <div class="dx-field">
                  <span style="color:darkred;">{{messaggioErrore}}</span>
                </div>
              }
              <div class="dx-field div-button">
                <dx-button stylingMode="contained" text="Cancella" icon="close" type="danger" height="40"
                  width="-webkit-fill-available" (onClick)="cancellaPopup()">
                </dx-button>
              </div>
              @if(authAvanzato && !authBase){
              <div class="dx-field div-button">
                <dx-button stylingMode="contained" text="Inserici utente" icon="user" type="success" height="40"
                  width="-webkit-fill-available" (onClick)="onAggiungiUtenteClick()">
                </dx-button>
              </div>
              }
             
            </div>
          </div>
        </dx-validation-group>
      </form>
    </div>
  </dx-popup>
</div>
}

<!--RESET PASSWORD-->
@if(popupResetPswVisible){
<dx-popup [width]="'65vw'" [height]="'55vh'" [(visible)]="popupResetPswVisible">
  <div class="content-block">
    <form>
      <div class="row">
        <div class="col-xs-12 col-lg-12">
          <div class="card">
            <div class="card-header">
              <h4>Reset password</h4>
            </div>
            <div class="card-body">
              @if (usernameResetPassword) {
              <app-ildato-new-password [username]="usernameResetPassword" [parametriPasswords]="parametriPasswords"
                (ilDatoNewPasswordEventEmitter)="
                    onIlDatoResetPasswordEvent($event)
                  "></app-ildato-new-password>
              }
            </div>
            <div class="dx-field">
              <dx-button stylingMode="contained" text="Cancella" icon="close" type="danger" class="cancella-btn"
                height="40" width="-webkit-fill-available" (onClick)="cancellaPopupResetPassword()">
              </dx-button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</dx-popup>
}